<template>
  <div class="courseDetailPage">
    <a-row :gutter="_isMobile() ? [0, 20] : [20, 20]">
        <a-col :xs="24" :sm="24" :md="8">
            <img src="../../assets/aice2/kec_image.png" style="width: 100%;" alt="">    
        </a-col>
        <a-col :xs="24" :sm="24" :md="16">
            <h2 class="courseTitle">2024年青少年科学工作室主题科技活动“美丽乡村”专题学习</h2>    
            <div class="couresInfoStyle">
                <i class="iconfont">&#xe615;</i>学习人数：1000 <a-divider type="vertical" /> <i style="color: #ea9518;" class="iconfont" v-for="i in 5" :key="i">&#xe604;</i> <span class="ant-rate-text">5</span>
            </div>
            <div class="couresInfoStyle">
               <i class="iconfont">&#xe62f;</i> 课时总数：1000 <a-divider type="vertical" /> 第一学期
            </div>
            <div class="couresInfoStyle">
               <i class="iconfont">&#xe607;</i> 开课时间： 2024-07-19 <a-divider type="vertical" /> 结课时间：2024-08-19
            </div>
            <div class="couresInfoStyle">
               <i class="iconfont">&#xebab;</i> 分享 <a-divider type="vertical" /> <i class="iconfont">&#xe614;</i> 收藏 (1)
            </div>
            <div style="font-size: 18px;color: red;margin: 10px 30px;">免费</div>
            <a-button type="primary" class="sumbitButton"> 立即报名 </a-button>
        </a-col>
    </a-row>
    <a-tabs default-active-key="1" @change="callback" style="width: 100%;">
      <a-tab-pane key="1" tab="课程介绍">
        <div class="detailTabBox">
            <p class="courseTitle">课程简介</p>
            <p class="courseContent">
                本在线培训课程，面向小学、初高中学段，围绕航天科普和青少年航天科技教育展开，主题是“青少年航天科普教育”。作为面向青少年航天科普教育领域科技辅导员培训交流活动系列在线课程，本课程在培训内容设计上综合吸收青少年航天科普教育领域和青少年航天科普科技创新教育领域的前沿成果，结合学会以往的青少年航天科普教育经验，以及85所航天特色校教育实践经验，努力探索“如何深入开展青少年航天科普教育”，形成系统和全面的青少年航天科普教育领域课程内容架构，完善信息化条件下的航天科普和青少年航天科技辅导员在线培训内容体系。
            </p>
            <p class="courseTitle">讲师简介</p>
            <div v-for="i in 5" :key="i">
                <p class="courseName">韩国军</p>
                <p class="courseContent">
                    高级工程师，北京航空航天大学航空航天博物馆任常务副馆长，中国高校博物馆专业委员会副主任委员兼秘书长
                </p>
            </div>
        </div>
      </a-tab-pane>
      <a-tab-pane key="2" tab="课程目录" force-render>
        <ul class="catalogueBox">
            <li class="cataloguelist" v-for="item,index in list" :key="index">
                <p class="catalogue1">{{item.name}}</p>
                <ul class="catalogueLevelBox">
                    <li v-for="i,n in item.list" :key="n" class="catalogueLevelList" @click="openVideoFn(i)">
                        <p>{{ i.name }}</p>
                        <div class="catalogueLevelListRight">
                            <p class="pTimer">{{ i.timer }}</p>
                            <p class="pButton"><i class="iconfont">&#xe61d;</i>试看</p>
                        </div>
                    </li>
                </ul>
            </li>
        </ul>
      </a-tab-pane>
    </a-tabs>
    <unitView-modal ref="unitViewModal" />
  </div>
</template>
<script>
import { mixinDevice } from "@/utils/mixin.js";
import UnitViewModal from '@/components/course/UnitViewModal'
export default {
    mixins: [mixinDevice],
  name: "",
  components: {UnitViewModal},
  data() {
    return {
        list:[
            {
                name:'第一章 二十四节气综合探究',
                list:[
                    {
                        name:'33333',
                        timer:'00:24:28'
                    },{
                        name:'44444',
                        timer:'00:24:28'
                    }
                ]
            },{
                name:'第二章 二十四节气综合探究',
                list:[
                    {
                        name:'33333',
                        timer:'00:24:28'
                    },{
                        name:'44444',
                        timer:'00:24:28'
                    }
                ]
            }
        ]        
    };
  },
  created() {},
  mounted() {},
  methods: {
    callback(){},
    openVideoFn(e){
        this.$refs.unitViewModal.view({id:'1712755187707330561'})
    },
  },
};
</script>
<style lang='scss' scoped>
  p {
    margin: 0;
  }
  ul,
  li {
    list-style: none;
    margin: 0;
    padding: 0;
  }
.courseTitle{
    font-size: 24px;
    font-weight: bold;
}
.couresInfoStyle{
    font-size: 12px;
    color: #999;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 4px 0;
    .iconfont{
        padding-right: 6px;
    }
}
.sumbitButton{
    padding: 0 50px;
    margin: 0 10px;
    background: #174EDA !important;
}
.detailTabBox{
    width: 100%;
    .courseTitle{
      font-size: 18px;
      font-weight: 600;
      color: #333;
      text-align: left;
    }
    .courseName{
        font-size: 16px;
        color: #333;
        padding: 0 20px;
        margin: 10px 0;
    }
    .courseContent{
        font-size: 14px;
        color: #999;
        line-height: 25px;
        padding: 0 20px;
        margin: 10px 0;
    }
}
.catalogueBox{
    width: 100%;
    .cataloguelist{
        width: 100%;
        .catalogue1{
            width: 100%;
            font-size: 24px;
            color: #333;
            background: rgb(249,249,249);
            padding: 10px;
        }
        .catalogueLevelList:hover{
            background: rgb(253, 246, 246);
        }
        .catalogueLevelList{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 20px;
            box-sizing: border-box;
            cursor: pointer;
            .catalogueLevelListRight{
                display: flex;
                align-items: center;
                justify-content: flex-end;
                line-height: 25px;
                .pButton{
                    width: 60px;
                    text-align: right;
                    .iconfont{
                        padding-right: 5px;
                    }
                }
            }
        }
    }
}
</style>
